import React from 'react';

import { RegistrationForm } from '../../components/library/registration-form/RegistrationForm';

export const RegistrationPage = () => {
  return <RegistrationForm />;
};
